import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/** Finans Raporları Dinamik Raporlar'a taşındı (Kaynak tasarımcısı modu). Eski bağlantılar için yönlendirme. */
const FinanceReports: React.FC = () => {
  const navigate = useNavigate();
  useEffect(() => { navigate("/dynamic-reports?mode=sources&source=CashTransactions", { replace: true }); }, [navigate]);
  return null;
};

export default FinanceReports;
